import _ from "lodash";
import api from "./api";
import endpoints from "./endpoints";
import { getAsAhexFromHexa, getAsHexaFromAhex } from "@util/color";
import { ArticleStateEntry } from "@medapro-types/ConfigurationManager/ConfigurationManager";

export default {
  get: async function (): Promise<ArticleStateEntry[]> {
    const response = await api.get(endpoints.articleStates.get);
    response.data = response.data.map((item: ArticleStateEntry) => Object.assign(item, { color: getAsHexaFromAhex(item.color) }));
    return response.data;
  },
  update: async function (articleStates: ArticleStateEntry[] | null) {
    const postData = _.cloneDeep(articleStates)?.map((item) => Object.assign(item, { color: getAsAhexFromHexa(item.color).toUpperCase() }));
    const response = await api.post(endpoints.articleStates.update, postData);
    return response.data;
  },
  delete: async function (articleStateIds: string[]) {
    const response = await api.post(endpoints.articleStates.delete, articleStateIds);
    return await Promise.resolve(response.data);
  }
};
